import React, { ReactElement } from 'react';
import { createUseStyles } from 'react-jss';
import Header from '../Header';

const useStyles = createUseStyles({
  container: {
    display: 'flex',
  },
});

function LegacyPayPal(): ReactElement {
  const classes = useStyles();

  return (
    <div className={ classes.container }>
      <Header title="Result of clicking Legacy PayPal Button" />
    </div>
  );
}

LegacyPayPal.defaultProps = {
  button: null,
};

export default LegacyPayPal;
